import type { Meta, StoryObj } from "@storybook/react";

import { TotalOnboardingSteps } from "@/constants/Onboarding";
import type { OnboardingContentHeaderProps } from "@/ui/components/onboarding/v2/OnboardingContentHeader";
import { OnboardingContentHeader } from "@/ui/components/onboarding/v2/OnboardingContentHeader";

const StoryMeta: Meta<OnboardingContentHeaderProps> = {
  title: "Components/Onboarding/Cards/Onboarding Content Header",
  component: OnboardingContentHeader,
  args: {
    currentStepIndex: 0,
    testID: "story",
  },
  argTypes: {
    currentStepIndex: {
      control: {
        max: TotalOnboardingSteps - 1,
        min: 0,
        step: 1,
        type: "range",
      },
    },
    onClosePress: {
      action: "onClosePress",
    },
    patientName: {
      control: "text",
    },
  },
};

type Story = StoryObj<OnboardingContentHeaderProps>;

const PatientView: Story = {};

const ProxyView: Story = {
  args: {
    patientName: "Renee",
  },
};

const MidProgress: Story = {
  args: {
    currentStepIndex: 3,
  },
};

export { MidProgress, PatientView, ProxyView };
export default StoryMeta;
